import { render, staticRenderFns } from "./orcamentosCliente.vue?vue&type=template&id=78b28c7d&"
import script from "./orcamentosCliente.vue?vue&type=script&lang=js&"
export * from "./orcamentosCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports